import { Factory } from './Factory'
import Menu from '../EditorComponents/Icon/Menu'

export class IconFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('icon'),
      containerId: this.id('container_icon'),
      slug: 'editor-icon',
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      customClasses: [],
      constantClasses: {
        phone: [
          {property: 'Display', value: 'FLEX'},
          {property: 'AlignItems', value: 'ALIGN_ITEMS_CENTER'},
          {property: 'JustifyContent', value: 'JUSTIFY_CENTER'}
        ],
        tablet: [],
        desktop:[]
      },
      containerClasses: {
        phone: [
          {property: 'Display', value: 'FLEX'},
          {property: 'AlignItems', value: 'ALIGN_ITEMS_CENTER'},
          {property: 'JustifyContent', value: 'JUSTIFY_CENTER'}
        ],
        tablet: [],
        desktop:[]
      },
      name: 'Icon',
    }
  }

  properties() {
    return {
      content: [
        {key: 'icon-content', component:'ContentIcon'},
        {key: 'border-color', component: 'BorderProperty', only: ['color']},
        {key: 'background-color', component: 'BackgroundProperty', only: ['color']},
        {key: 'rounded-content', component: 'RoundedProperty'},
        {key: 'size-content', component: 'ContentSizeProperty'},
      ],
      styles: [
        {key: 'rotation-content', component: 'IconRotationProperty', class: 'iconClasses'},
        {key: 'animation-content', component: 'IconAnimationProperty', class: 'iconClasses'},
        {key: 'size-icon', component: 'IconSizeProperty', class: 'iconClasses'},
        {key: 'icon-color', component: 'IconColorProperty', class: 'iconClasses', styles: 'iconStyles'},
        {key: 'margin', component: 'MarginProperty'},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
    }
  }
}
